import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// import Grid from '@mui/material/Grid';
// import ProcedureIcon from '@mui/icons-material/VolunteerActivismOutlined';

import { ProceduresTableContainer } from '../../components/procedures';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors, fetchDocuments } from '../../actions/adminActions';
import { fetchProducts } from '../../actions/productsActions';

import './admin.scss';

const ProceduresPage = ({ procedures, distributors, products, documents, fetchDistributors, fetchProducts, fetchDocuments }) => {
  useEffect(() => {
    fetchDistributors();
    fetchProducts();
    fetchDocuments();
  }, [fetchDistributors, fetchProducts, fetchDocuments]);

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Procedures' number={procedures?.length} icon={<ProcedureIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Procedures' number={procedures?.length} icon={<ProcedureIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Procedures' number={procedures?.length} icon={<ProcedureIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <ProceduresTableContainer
        procedures={procedures}
        distributors={distributors}
        products={products}
        documents={documents}
        withButton
      />
    </div>
  );
};

ProceduresPage.propTypes = {
  procedures: PropTypes.array,
  distributors: PropTypes.array,
  fetchDistributors: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  procedures: state.procedures.list,
  distributors: state.distributors.list,
  products: state.products.list,
  documents: state.documents.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
  fetchProducts: () => dispatch(fetchProducts()),
  fetchDocuments: () => dispatch(fetchDocuments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProceduresPage);
